import { render, staticRenderFns } from "./YourSkinSection.vue?vue&type=template&id=a8eb92b6&"
import script from "./YourSkinSection.vue?vue&type=script&lang=js&"
export * from "./YourSkinSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports